import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle, Mail } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const status = params.get("status"); // success | already | invalid
  const email = params.get("email") || "";

  const renderContent = () => {
    if (status === "success") {
      return (
        <div className="text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: "rgba(22,163,74,0.12)" }}>
            <CheckCircle2 className="w-9 h-9" style={{ color: "var(--success)" }} />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--text)" }}>
            You're unsubscribed
          </h1>
          {email && (
            <p className="text-sm mb-1" style={{ color: "var(--text-soft)" }}>
              <strong style={{ color: "var(--text)" }}>{decodeURIComponent(email)}</strong> has been removed from all future campaigns.
            </p>
          )}
          <p className="text-sm" style={{ color: "var(--text-soft)" }}>
            You won't receive any more marketing emails. If this was a mistake, please contact the sender directly.
          </p>
        </div>
      );
    }

    if (status === "already") {
      return (
        <div className="text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: "var(--brand-dim)" }}>
            <Mail className="w-9 h-9" style={{ color: "var(--brand)" }} />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--text)" }}>
            Already unsubscribed
          </h1>
          {email && (
            <p className="text-sm" style={{ color: "var(--text-soft)" }}>
              <strong style={{ color: "var(--text)" }}>{decodeURIComponent(email)}</strong> is already opted out of all campaigns.
            </p>
          )}
        </div>
      );
    }

    if (status === "invalid") {
      return (
        <div className="text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: "rgba(239,68,68,0.1)" }}>
            <AlertCircle className="w-9 h-9" style={{ color: "#EF4444" }} />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--text)" }}>
            Invalid link
          </h1>
          <p className="text-sm" style={{ color: "var(--text-soft)" }}>
            This unsubscribe link is invalid or has already been used. Please contact us directly if you need help.
          </p>
        </div>
      );
    }

    // Default — no params
    return (
      <div className="text-center">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
          style={{ background: "var(--brand-dim)" }}>
          <Mail className="w-9 h-9" style={{ color: "var(--brand)" }} />
        </div>
        <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--text)" }}>
          Email Preferences
        </h1>
        <p className="text-sm" style={{ color: "var(--text-soft)" }}>
          To unsubscribe from a campaign, click the unsubscribe link at the bottom of one of our emails.
          If you believe this is a mistake, please contact the sender directly.
        </p>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md">
        {/* Logo / Brand */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-sm font-bold" style={{ background: "var(--brand)" }}>L</div>
            <span className="text-lg font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--text)" }}>LaunchDeck</span>
          </div>
        </div>

        {/* Card */}
        <div className="card-premium rounded-2xl p-8 text-center"
          style={{ background: "var(--surface)", border: "1px solid var(--border)" }}>
          {renderContent()}

          <div className="mt-6 pt-6 border-t" style={{ borderColor: "var(--border)" }}>
            <Link to="/signin" className="text-sm hover:underline" style={{ color: "var(--brand)" }}>
              Return to LaunchDeck
            </Link>
          </div>
        </div>

        <p className="text-center text-xs mt-6" style={{ color: "var(--text-xsoft)" }}>
          This page is powered by LaunchDeck Email Marketing
        </p>
      </div>
    </div>
  );
}
